import { useRef, useState, useEffect } from "react";
import Link from "next/link";
import CommonImage from "../image/CommonImage";

export default function UniversityCard({ uni }) {
  const titleRef = useRef(null);
  const [displayName, setDisplayName] = useState(uni.name);

  useEffect(() => {
    const checkWidth = () => {
      if (titleRef.current) {
        const textWidth = titleRef.current.scrollWidth;
        if (textWidth > 288) {
          setDisplayName(uni.short_name);
        } else {
          setDisplayName(uni.name);
        }
      }
    };

    checkWidth();
    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
  }, [uni.name, uni.short_name]);

  return (
    <Link href={`university/${uni?.slug}`}>
      <div className="university-name-card">
        <div className="university-logo-wrap">
          <CommonImage
            src={uni.logo ?? "/images/home/jahingirnagar-university.png"}
            className="university-logo"
            alt={uni.name}
          />
        </div>
        <div className="university-name">
          <h3 className="title" ref={titleRef}>
            {displayName}
          </h3>
        </div>
      </div>
    </Link>
  );
}
